// Thin wrapper over Radix Themes' Tabs for the five campaign-detail tabs.
//
// The parent owns the active-tab state and the panel rendering, so this file
// is just the tab list itself.

import { Box, Tabs } from '@radix-ui/themes';

export type CampaignTabKey =
  | 'surfaces'
  | 'sampler'
  | 'convergence'
  | 'points'
  | 'provenance';

const TAB_ORDER: Array<{ key: CampaignTabKey; label: string }> = [
  { key: 'surfaces', label: 'Surfaces' },
  { key: 'sampler', label: 'Sampler' },
  { key: 'convergence', label: 'Convergence' },
  { key: 'points', label: 'Points' },
  { key: 'provenance', label: 'Provenance' },
];

export type TabSwitcherProps = {
  value: CampaignTabKey;
  onChange: (next: CampaignTabKey) => void;
};

export function TabSwitcher({ value, onChange }: TabSwitcherProps) {
  return (
    <Box
      style={{
        borderBottom: '1px solid var(--gray-a5)',
        background: 'var(--color-panel-solid)',
        padding: '0 16px',
      }}
    >
      <Tabs.Root
        value={value}
        onValueChange={(v) => onChange(v as CampaignTabKey)}
      >
        <Tabs.List>
          {TAB_ORDER.map((tab) => (
            <Tabs.Trigger key={tab.key} value={tab.key}>
              {tab.label}
            </Tabs.Trigger>
          ))}
        </Tabs.List>
      </Tabs.Root>
    </Box>
  );
}

export default TabSwitcher;
